<template>
  <!-- 社教活动管理 -->
  <div class="page-activity-manage">
    <!-- 列表头部 -->
    <div class="com-list-header" style="paddingRight: 20px;padding-bottom: 10px">
      <el-form @keyup.enter.native="getTableList" :model="form" class="com-search-box" ref="form" label-width="80px">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="期刊名称 :" prop="name">
              <el-input v-model="form.name" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>

          <!-- <el-col :span="6">
            <el-form-item label="期刊编号 :" prop="bookNo">
              <el-input v-model="form.bookNo" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="出版社 :" prop="publisher">
              <el-input v-model="form.publisher" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col> -->

          <!-- <el-col :span="6">
            <el-form-item label="作者 :" prop="author">
              <el-input v-model="form.author" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col> -->
        </el-row>
      </el-form>

      <div class="com-head-search-btns">
        <el-button type="primary" @click="getTableList">查询</el-button>
        <el-button @click="restList('form')">重置</el-button>
      </div>

    </div>

    <!-- 列表内容 -->
    <div class="com-list-content">
      <!-- <div class="button">
        <el-row type="flex">
          <el-button style="margin-right: 20px" @click="addBook" class="el-primary-border">
            <svg-icon icon-class="add" />&nbsp;新增期刊
          </el-button>

          <el-upload ref="bookImport" :show-file-list="false" action="/singleMuseum/book/bsBookInfo/export" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" :data="uploadData">
            <el-button class="el-primary-border">
              <svg-icon icon-class="add" />&nbsp;导入
            </el-button>
          </el-upload>
        </el-row>
      </div> -->
      <div class="table mt-20">
        <el-table ref="multipleTable" v-loading="listLoading" stripe :data="tableData">
          <el-table-column label="序号" width="50">
            <template slot-scope="scope">{{ scope.$index+1 }}</template>
          </el-table-column>
          <el-table-column prop="name" label="期刊名称" min-width="10%" show-overflow-tooltip></el-table-column>
          <el-table-column prop="pinyinsuoxie" label="拼音缩写" min-width="10%" show-overflow-tooltip></el-table-column>

          <!-- <el-table-column prop="author" label="作者" min-width="7%"></el-table-column> -->
          <!-- <el-table-column prop="publisher" label="出版社" min-width="7%"></el-table-column> -->
          <!-- <el-table-column prop="bookNumber" label="书号" min-width="7%"></el-table-column> -->
          <el-table-column prop="publishTime" label="出刊日期" min-width="10%" show-overflow-tooltip></el-table-column>
          <el-table-column prop="total" label="总数" min-width="7%"></el-table-column>
          <el-table-column prop="remain" label="剩余数" min-width="7%"></el-table-column>
          <el-table-column prop="bak" label="备注" min-width="7%"></el-table-column>
          <el-table-column fixed="right" label="操作" min-width="10%">
            <template slot-scope="scope">
              <a class="m-btn mr-10" @click="borrowBook(scope.row.id)">借阅</a>
              <a class="m-btn mr-10" v-if="scope.row.attachment" @click="download(scope.row)">下载</a>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container paging">
          <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>

    <el-dialog title="新增期刊" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <el-form class="g-form-grid" ref="addForm" :model="addForm" label-width="120px" :rules="rules">
        <el-form-item label="期刊名称 :" prop="name">
          <el-input v-model="addForm.name" placeholder="请输入"></el-input>
        </el-form-item>

        <el-form-item label="拼音缩写 :" prop="pinyinsuoxie">
          <el-input v-model="addForm.pinyinsuoxie" placeholder="请输入"></el-input>
        </el-form-item>

        <el-form-item label="出刊时间 :" prop="publishTime">
          <el-date-picker v-model="addForm.publishTime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" type="date" placeholder="请选择"></el-date-picker>
        </el-form-item>
        <el-form-item label="备注（原编号） :" prop="bak">
          <el-input v-model="addForm.bak" placeholder="请输入"></el-input>
        </el-form-item>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="借阅期刊" :visible.sync="dialogVisible1" width="30%">
      <el-form class="g-form-grid" ref="borrowForm" :model="borrowForm" label-width="90px" :rules="borrowRules">
        <el-form-item label="借阅数量 :" prop="num">
          <el-input v-model.number="borrowForm.num" placeholder="请输入"></el-input>
        </el-form-item>

        <el-form-item label="借阅天数 :" prop="day">
          <el-input v-model="borrowForm.day" placeholder="请输入"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose1">取 消</el-button>
        <el-button type="primary" @click="handleBorrow()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import cmpUploadProgress from '@cmp/my-upload/upload-progress' // 上传组件
import axios from 'axios'
export default {
  components: {
    cmpUploadProgress
  },
  data() {
    return {
      that: this,
      form: {
        name: '',
        type: 2
      },
      addForm: {
        name: '',
        publishTime: '',
        pinyinsuoxie: '',
        bak: '',
        type: 2
      },
      borrowForm: {
        num: '',
        day: '',
        type: 2
      },
      rules: {
        name: [
          { required: true, message: '期刊名称不能为空', trigger: 'blur' },
        ],

        pinyinsuoxie: [
          { required: true, message: '拼音缩写不能为空', trigger: 'blur' },
        ],

        publishTime: [
          { required: true, message: '出刊时间不能为空', trigger: 'blur' },
        ],

      },

      borrowRules: {
        num: [
          { required: true, message: '请输入借阅数量', trigger: 'blur' },
        ],
      },
      borrowId: '',
      listLoading: true,
      tableData: [],
      bookTypeList: [],
      listQuery: {
        currentPage: 1,
        size: 10
      },
      bookStatus: [{
        dictCode: 1,
        dictName: '可借阅'
      }, {
        dictCode: 2,
        dictName: '可阅览'
      }],
      total: 0,
      uploadData: {
        file: '',
        type: 2
      },
      dialogVisible: false,
      dialogVisible1: false
    }
  },

  filters: {
    filterBookType(type, that) {
      let obj = that.bookTypeList.filter(item => {
        return item.dictCode == type
      })

      if (obj && obj.length > 0) {
        return obj[0].dictName
      }

      return null
    },
    filterStatus(status) {
      if (status == 1) {
        return '可借阅'
      } else if (status == 2) {
        return '可阅览'
      } else {
        return null
      }
    }
  },

  methods: {
    initData() {
      this.listLoading = true
      this.tableData = []
      this.$api.book.getBookPageList({
        ...this.form,
        ...this.listQuery
      }).then(res => {
        if (res.success) {
          this.tableData = res.result.records
          this.total = res.result.total
        }
        this.listLoading = false
      }).catch(err => {
        this.listLoading = false
      })

    },
    
    getTableList(){
      this.listQuery.currentPage = 1
      this.initData()
    },

    // 获取下拉状态多选择值
    getDropdownValue() {
      this.$http.get('/collectDict/getSelectDataByKey', {
        key: 'book_type'
      }).then(res => {
        if (res.success) {
          this.bookTypeList = res.result
        } else {
          this.$message.error(res.message)
        }
      })
    },

    // 详情
    borrowBook(id) {
      this.borrowId = id
      this.dialogVisible1 = true
    },

    // 文件上传回调
    uploadCallback(fileStr) {
      this.addForm.attachment = fileStr
    },

    //下载图书
    download(obj) {
      axios({
        method: 'get',
        url: '/singleMuseum/book/bsBookInfo/download',
        responseType: 'blob', //二进制流
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        params: {
          attachmentId: obj.attachment
        }
      }).then(res => {
        if (res) {
          let fileName = obj.name;
          const blob = new Blob([res.data]);
          if (res.headers) {
            let contentDisposition = res.headers['content-disposition'];
            if (contentDisposition) {
              fileName = window.decodeURI(res.headers['content-disposition'].split('=')[1], "UTF-8");
            }
            // if (fileName) {
            //   fileName = fileName.split('.')[0]
            // }
          }
          const linkNode = document.createElement('a');
          linkNode.setAttribute('download', fileName);
          linkNode.style.display = 'none';
          linkNode.href = URL.createObjectURL(blob); //生成一个Blob URL
          document.body.appendChild(linkNode);
          linkNode.click();  //模拟在按钮上的一次鼠标单击

          URL.revokeObjectURL(linkNode.href); // 释放URL 对象
          document.body.removeChild(linkNode);
        }
      })
    },

    restList(formName) {
      this.$refs[formName].resetFields();
      this.listQuery.currentPage = 1
      this.initData()
    },

    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.initData()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.initData()
    },

    addBook() {
      this.dialogVisible = true
    },

    handleClose() {
      this.$refs['addForm'].resetFields()
      // this.$refs['cmpUploadProgress'].viewFileList = []
      this.dialogVisible = false
    },

    handleClose1() {
      this.$refs['borrowForm'].resetFields()
      this.dialogVisible1 = false
    },

    beforeAvatarUpload(file) {
      let formData = new FormData()
      formData.append('file', file.raw)
      this.uploadData.file = formData
    },

    handleAvatarSuccess(res) {
      if (res.success) {
        this.$message.success('导入成功')
        this.initData()
      } else {
        this.$message.error(res.message)
      }
    },

    //借阅期刊
    handleBorrow() {
      this.$refs['borrowForm'].validate(vaild => {
        if (vaild) {
          this.$api.book.borrowBook({
            num: this.borrowForm.num,
            type: 2,
            day: this.borrowForm.day ? parseInt(this.borrowForm.day) : 0,
            id: this.borrowId
          }).then(res => {
            if (res.success) {
              this.$message.success('借阅成功')
              this.handleClose1()
              this.initData()
            } else {
              this.$message.error(res.message)
            }
          })
        }
      })
    },

    handleSubmit() {
      this.$refs['addForm'].validate(vaild => {
        if (vaild) {
          this.$api.book.addBookInfo({
            ...this.addForm,
          }).then(res => {
            if (res.success) {
              this.$message.success('新增成功')
              this.handleClose()
              this.initData()
            } else {
              this.$message.success(res.message)
            }
          })
        }
      })
    }

  },

  mounted() {
    this.getDropdownValue()
    this.initData()
  }
}
</script>

<style lang="scss" scoped>
.btn-wrapper {
  display: flex;
  justify-content: right;
  margin: 10px 0;
}
</style>